import React, {useState, useCallback} from 'react';
import {useWindowClearer} from "components/sidebar/useWindowClearer.js";

export const useContextMenu = ({ref, useTop=true, useLeft=true}) => {
    let [dropdownPos, setDropdownPos] = useState(undefined);
    useWindowClearer({clear: () => setDropdownPos(undefined), selected: dropdownPos});

    const onContextMenu = useCallback((e) => {
        e.preventDefault();
        // e.stopPropagation();
        if (ref) {
            let rect = ref.current.getBoundingClientRect();
            setDropdownPos({
                x: useLeft ? e.clientX - rect.left : e.clientX,
                y: useTop ? e.clientY - rect.top : e.clientY
            });
        } else {
            setDropdownPos({x: e.clientX, y: e.clientY});
        }
    }, [setDropdownPos, useTop, useLeft]);

    return {onContextMenu, dropdownPos, setDropdownPos};
};
